import styled from 'styled-components';

export const SearchErrorImage = styled.img`
  width: 18vw;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 45px;
  margin-top: 25px;
  @media (max-width: 640px) {
    width: 211px;
  }
`;

export const ErrorHeadingStyles = styled.div`
  color: rgb(74, 77, 78);
  font-family: 'Vodafone', sans-serif;
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: center;
  white-space: pre-wrap;
  width: 50vw;
  margin: 0 auto 30px auto;
  @media (max-width: 640px) {
    width: 100% !important;
  }
`;

export const ErrorDescriptionStyles = styled.div`
  color: #4a4d4eab;
  text-align: center;
  @media (max-width: 640px) {
    width: 92vw;
  }
`;

export const ButtonStyles = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 30px 0;
`;
